import { MatterStatus } from '../constants/matter';
import { IAddress } from './address';
import { IBusinessArea } from './businessArea';
import { IMatterParties } from './matterParties';
import { IPrincipalCompany } from './principalCompany';
import { IPrincipalPrivatePerson } from './principalPrivatePerson';
import { ITransactionTypes, ITranslations } from './transactionTypes';
import { IUnit } from './unit';
import { IUser } from './user';

export interface IMatter {
  id: string;
  subject: string;
  matterNumber: string;
  currency: string;
  invoiceableType: string;
  hasImportantNotes: boolean;
  hasImportantRelatedNotes: boolean;
  hasNotes: boolean;
  principalCompanyId: string;
  principalCompany: IPrincipalCompany;
  principalPrivatePersonId: string;
  principalPrivatePerson: IPrincipalPrivatePerson;
  isFavorite: boolean;
  language: string;
  hasLinkedTransactionTypes: boolean;
  defaultTransactionTypeId: string;
  responsibleUserId: string;
  responsibleUser: IUser;
  openingDate: string;
  lastEntryDate: string;
  parties: IMatterParties[];
  status: MatterStatus;
  ownerUser: IUser;
  matterType: IMatterType;
  businessUnit: IBusinessUnit;
  businessArea?: IBusinessArea;
  conflictCheckDoneDate?: string;
  periodStartDate?: string;
  periodEndDate?: string;
  invoicingUser?: IUser;
  sumOfBillableEntriesInCurrency?: number;
  sumOfBillableEntries?: number;
  customerIdentificationStatus: CustomerIdentificationStatus;
  hasSubMatters?: boolean;
  parentMatterId?: string;
  transactionType?: ITransactionTypes;
  transactionTypeId: string;
  unitId: string;
  unit: IUnit;
  showOnlyOwnEntries?: boolean;
  fixedPriceInUse?: boolean;
  insider?: boolean;
  fixedPrice?: number;
}
export interface IMatterType {
  translations: ITranslations[];
  status: string;
  description: string;
  name: string;
  id?: string;
}
export interface IBusinessUnit {
  status: string;
  name: string;
  businessId: string;
  vatNumber: string;
  homeCountry: string;
  language: string;
  registeredOffice: string;
  headOffice: boolean;
  primaryAddressId: string;
  phone?: string;
  fax?: string;
  email?: string;
  website?: string;
  logo?: string;
  primaryAddress?: IAddress;
}
export enum MatterTabSections {
  matters = 'matters',
  matterRequests = 'matterRequests',
}

export enum MatterSections {
  general = 'general',
  entries = 'entries',
  parties = 'parties',
  identification = 'identification',
  notes = 'notes',
}
export enum MatterRequestSections {
  general = 'general',
  parties = 'parties',
  identification = 'identification',
  notes = 'notes',
}
export enum CustomerIdentificationStatus {
  NOT_REQUIRED = 'not-required',
  IDENTIFIED = 'identified',
  REQUIRED = 'required',
  STARTED = 'started',
}
